import { useMenuItemsModel } from "./useMenuItemsModel"
import { MenuLayoutSectioned } from "./layouts/MenuLayoutSectioned"

interface MenuItemsProps {
  mobile?: boolean
  onNav: () => void
}

function MenuItems({ mobile, onNav }: MenuItemsProps) {
  const m = useMenuItemsModel(onNav)
  return <MenuLayoutSectioned m={m} mobile={Boolean(mobile)} />
}

export default MenuItems
